import actions from './actions';
import getters from './getters';
import mutations from './mutations';

export const initState = () => ({
  error: null,
  isLoading: false,
  isAdding: false,
  isHandling: false,
  isRefreshing: false,
  detail: null,
  paging: null,
  roles: [],
  users: [],
});

export default {
  namespaced: true,
  state: initState(),
  getters,
  mutations,
  actions,
};
